import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { updateUserProfile } from '../services/hcp_profile';

export const useUpdateUserProfile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const queryClient = useQueryClient();

  const updateProfile = async (profileData) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await updateUserProfile(profileData);

      await queryClient.invalidateQueries(['userProfile']);

      setIsLoading(false);
      return result;
    } catch (err) {
      setError(err.message || 'Failed to update profile');
      setIsLoading(false);
      throw err;
    }
  };

  return {
    updateProfile,
    isLoading,
    error
  };
};
